<div class="page">
  <a gs1ReturnButton class="gs1-spacer-3" [routerLink]="'/mes-gln'">Revenir à la liste</a>
  <ng-container *ngIf="!create; else creation">
    <ng-container *ngIf="gln; else loading">
      <ng-container *ngIf="!edit || (edit && gln && gln.status && gln.status !== 'DRAFT')">
        <single-page [gln]="gln" (stopEdit)="finishingEdit($event)" (startEdit)="startEdit()"></single-page>
      </ng-container>
      <ng-container *ngIf="edit && (gln && (!gln.status || gln.status === 'DRAFT'))">
        <creation-gln [currentGln]="gln ? gln : undefined"></creation-gln>
      </ng-container>
    </ng-container>

  </ng-container>
</div>

<ng-template #creation>
  <creation-gln [currentGln]="gln ? gln : undefined"></creation-gln>
</ng-template>


<ng-template #loading>
  <div class="spinner-wrapper">
    <div gs1Spinner [big]="true" size="60px"></div>
  </div>
</ng-template>
